'use strict'
import api from '@/api/api'
import notify from '@/utils/notify'

export default {
  async listTemplates() {
    const data = { method: 'get', url: 'review-templates' }
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },

  async createTemplate(json) {
    const data = { method: 'post', url: 'review-templates', body: json }
    const response = await api.api(data)
    if (response.status === 201 || response.status === 200) {
      notify.alert.success('Review template created successfully')
      return response.data
    }
  },

  async getTemplate(id) {
    const data = { method: 'get', url: `review-templates/${id}` }
    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async updateTemplate(id, json) {
    const data = { method: 'patch', url: `review-templates/${id}`, body: json }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Review template updated successfully')
      return response.data
    }
  },

  async deleteTemplate(id) {
    const data = { method: 'delete', url: `review-templates/${id}` }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Review template deleted successfully')
      return true
    }
  },

  async setAsDefault(id) {
    const data = { method: 'post', url: `review-templates/${id}/set-default` }
    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Default template updated')
      return response.data
    }
  },
}
